module.exports = __webpack_public_path__ + "img/home1.3b1518ec.png";